import React from "react";
import { BetSelections } from "@tvg/design-system";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import { VisualSelections } from "@tvg/ts-types/Bet";
import { SimpleBetSelectionsProps } from "../types";

const SimpleBetSelections = ({
  selectionsList,
  betTypeNames
}: SimpleBetSelectionsProps) => (
  <>
    {selectionsList &&
      selectionsList.map(
        (item: VisualSelections, index) =>
          item &&
          item.length > 0 && (
            <BetSelections
              key={`simple-bet-selections-${index.toString()}`}
              qaLabel="bet-slip-selections"
              type={
                (betTypeNames[index as number] || "WN") as WagerTypeCodesEnum
              }
              selections={item}
            />
          )
      )}
  </>
);

export default SimpleBetSelections;
